import { API_ROUTES } from '@/lib/constants';
import { createCrudService } from './crud.factory';
import type { Payment } from '@/types/table';

export const paymentService = {
  ...createCrudService<Payment>(API_ROUTES.PAYMENTS),
};
